import CallError from '../../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../../utils/general';
import { envSetup } from '../setup';

/**
 * Gets available env list per envId
 * @param {object} params - an object of params
 * @param {string} params.accessToken - the access token required to get make the request
 */
export default async (params, signal = null) => {
  const requiredParams = [
    'accessToken',
    'orgId',
    'appId',
    'envId',
    'appVersion',
    'eventProviders',
    'productProfiles',
    'envConfig',
  ];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    envId: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
    appVersion: { allowedTypes: ['string'] },
    eventProviders: { allowedTypes: ['object'] },
    productProfiles: { allowedTypes: ['array'] },
    envConfig: { allowedTypes: ['object'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(`${envSetup.endpoint}/v1/environments/${params.envId}/deployments`, {
    signal,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${params.accessToken}`,
      'Content-Type': 'application/json',
      'x-gw-ims-scope': 'isv-installation-service.read,isv-installation-service.write',
      'x-app-version-id': params.appVersion,
      'x-ims-org-id': params.orgId,
      'x-api-key': envSetup.apiKey,
      'x-app-id': params.appId,
    },
    body: JSON.stringify({
      appVersion: params.appVersion,
      eventProviders: params.eventProviders,
      productProfiles: params.productProfiles,
      config: params.envConfig,
    }),
  });

  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }
  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response?.error });
  } else {
    return content;
  }
};
